document.addEventListener('DOMContentLoaded', () => {
  // Check if the webform with the specified ID exists on the page
  const webform = document.getElementById('webform-submission-form-afspraak-v2-node-2895-add-form');

  if (webform) {
    const selectList = document.getElementById('edit-dag-gooik');
    const parentDiv = document.getElementById('edit-datum-gooik');

    // Select all elements with class .webform-flex.webform-flex--1 except the first child
    const divsToToggle = parentDiv.querySelectorAll('.webform-flex.webform-flex--1:not(:first-child)');
    console.log(divsToToggle);

    selectList.addEventListener('change', () => {
      const selectedValue = selectList.value;

      // Hide all divs initially
      divsToToggle.forEach((div) => {
        div.style.display = 'none';
      });

      if (selectedValue === 'Maandag') {
        // Show only the first div when "Maandag" is selected
        divsToToggle[0].style.display = 'block';
      } else if (selectedValue !== '') {
        // Show the second div if the select list is not empty and not "Maandag"
        divsToToggle[1].style.display = 'block';
      }
    });

    // Trigger the change event initially to set the initial state
    selectList.dispatchEvent(new Event('change'));
  }
});
